export default __webpack_public_path__ + "static/media/birthday.833e5c62.png";